import {emailSettingState} from '../state/emailSettingState';
import {Fetch_Email_Setting_Success_Data,Update_Email_Setting_Success_Data,
    SMTP_REQUEST, SMTP_SUCCESS, UPDATE_SMTP_SUCCESS, ADD_SUBJECT_REQUEST,
    ADD_SUBJECT_SUCCESS, GET_SUBJECT_REQUEST, GET_SUBJECT_SUCCESS,
    APPLICATION_REQUEST, APPLICATION_SUCCESS, ADD_APPLICATION_SUCCESS} from '../action/emailSettingAction';


export function EmailSettingReducer(state = emailSettingState, action) {
    switch (action.type) {
        case Fetch_Email_Setting_Success_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                emailSettingList : action.emailSettingList
            })
        case Update_Email_Setting_Success_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                updatedEmailSetting : action.updatedList
            })
        case SMTP_REQUEST:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                isLoading : action.isLoading,
                // SMTPdetail: {},
                Message : ''
            })
        case SMTP_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                isLoading : action.isLoading,
                SMTPdetail: action.mailTransferProtocol
            })
        case UPDATE_SMTP_SUCCESS:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                isLoading : action.isLoading,
                Message: action.Message
            })
        case ADD_SUBJECT_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message : ''
            })
        case ADD_SUBJECT_SUCCESS:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: action.isLoading,
                Message : action.message
            })
        case GET_SUBJECT_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message : ''
            })
        case GET_SUBJECT_SUCCESS:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: action.isLoading,
                SubjectList : action.list
            })
        case APPLICATION_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message: ''
            })
        case APPLICATION_SUCCESS:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: action.isLoading,
                emailLogoDetail: action.emailLogoData
            })
        case ADD_APPLICATION_SUCCESS:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: action.isLoading,
                Message: action.Message
            })
        default : 
            return state
    }
}